export enum Breadcrumb {
    REPORT_LIST = 'Report List',
    HISTORY = 'History'
}